import apiClient, {errorHandling, errorConsole} from '../apiClient';

const usuariosServices = {

  cambiarClave: async (params) => {
    try {
      const response = await apiClient.put(`/usuarios/cambiarClave`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  olvidoClave: async (usuario) => {
    try {
      const response = await apiClient.post(`/passwords/forgot`, {usuario: usuario});

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  recuperoClave: async (params) => {
    try {
      const response = await apiClient.post(`/passwords/reset`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  activarUsuario: async (token) => {
    try {
      const response = await apiClient.post(`/passwords/activarUsuario`, token);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default usuariosServices;
